import React from 'react'
import Hero from '../components/Hero';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

export type ProcessOfCertificationPageProps = {};

const ProcessOfCertificationPage: React.FC<ProcessOfCertificationPageProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero 
        bgImage={'/img/process-checkmark.png'} 
        heading={
          intl.formatMessage({
            id: 'proc-cert'
          })
        }
      />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-6 !pt-8">
        <h2 className="text-2xl text-secondary font-bold uppercase">{
          intl.formatMessage({
            id: 'proc-cert'
          })
        }</h2>
        <div className="flex flex-col gap-4 mt-4 mb-8">
          <p>
            {
              intl.formatMessage({
                id: 'at_mcb',
              })
            }
          </p>
        </div>
        <div className="w-full flex flex-col md:flex-row items-center justify-between mb-12 gap-4">
          <Link to="/certification-services/process-of-certification/electronics" className="w-full sm:w-auto bg-secondary text-white py-1 px-4 font-bold uppercase">
            {
              intl.formatMessage({
                id: 'electronics'
              })
            }
          </Link>
          <Link to="/certification-services/process-of-certification/telecom" className="w-full sm:w-auto bg-secondary text-white py-1 px-4 font-bold uppercase">
            {
              intl.formatMessage({
                id: 'telecommunications'
              })
            }
          </Link>
        </div>
        <div className="w-full mb-10">
          <img src="/img/electronics-viz.jpg" alt="Electronics Certification Process" />
        </div>
      </div>
    </div>
  );
}

export default ProcessOfCertificationPage;